var Utils = require("./utils");
var queryArray = Utils.queryArray;

var members = queryArray(".list-view .list-items .item");

members.forEach(function(item) {
  var bounding = item.getBoundingClientRect();
  if (
    bounding.right + bounding.width >
    (window.innerWidth || document.documentElement.clientWidth)
  ) {
    item.classList.add("right");
  } else {
    item.classList.remove("right");
  }
});

window.addEventListener("resize", function() {
  members.forEach(function(item) {
    var bounding = item.getBoundingClientRect();
    if (
      bounding.right + bounding.width >
      (window.innerWidth || document.documentElement.clientWidth)
    ) {
      item.classList.add("right");
    } else {
      item.classList.remove("right");
    }
  });
});
